import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';

function LogoutModal(props) {
    const navigate = useNavigate();

  const handleClose = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('authToken');
    // localStorage.removeItem('cartItems');

    navigate('/')
    
  };

  return (
    <>

      <Modal {...props} centered>
        <Modal.Header closeButton className='border-0'>
          <Modal.Title className='border-0' >Are You Sure?</Modal.Title>
        </Modal.Header>
        {/* <Modal.Body>Woohoo, you are reading this text in a modal!</Modal.Body> */}
        <Modal.Footer className='border-0' >
          <Button variant="secondary" onClick={() => {props.onHide() }}>
            Cancel
          </Button>
          <Button style={{ background: 'rgb(57, 109, 114)' }} variant="primary" onClick={handleClose}>
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default LogoutModal;